import React from 'react'

import { ProductLabelStatus } from '../../graphql/search'
import { useLabelStatusForCartItemSku } from '../../lib/cart/state/cart-items/cart-item-remove'

interface RequireLabelStatusPresentProps {
  sku: string
  children: React.ReactNode
}

const RequireLabelStatusPresent: React.FC<RequireLabelStatusPresentProps> = ({ sku, children }) => {
  const result = useLabelStatusForCartItemSku(sku)
  if (result._tag === 'Left') {
    return null
  }
  return result.data.labelStatus === ProductLabelStatus.Present ? <>{children}</> : null
}

export default RequireLabelStatusPresent
